import Vue from 'vue'
import Vuex from 'vuex'
import settings from './modules/settings'

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    //加载中镜头
    lensStatus: [],

    //加载失败镜头
    lensError: [],

    visitedViews: [],

    powerArr: [],//按钮权限字段

    allPowerArr: {},//按钮vip类型权限字段

    vipType: 0,//VIP类型

    cameraAnimation: false,//相机动画

    //台词遮罩数据
    allCartoonData: {
      dialogue: [],
      imgMask: []
    },

    winDevicePixelRatio: 1,//窗口比例

    //tooltip提示
    btnTooltip: {
      editMode: {
        //编辑模式
        tip: '',
        btn: {
          sensitiveWordReplacement: "",//敏感词替换
          automaticOptimization: "",//一键优化
          fullDialogueAudioGeneration: "",//全对白音频生成
          dialogueAudioReplace: "",//对白音频替换
          cartoonAnalysis: "",//漫画解析
          isCartoonAnalysis: "",//漫画解析中
          originalSubtitle: "",//原始字幕
          antianaphylaxisSubtitle: "",//脱敏字幕
          antianaphylaxis: "",//脱敏
          convertToHD: "",//图片转高清
          importDubbing: "",//导入配音
          importImg: "",//导入图片
          addCamera: "",//新增镜头
          importSubtitles:"",//导入字幕
        },
        table: {
          lensNumber: "",//镜头号
          thumbnail: "",//缩略图
          dialogue: "",//台词
          dubbing: "",//配音
          pictureMotion: "",//画面运动
          lensLength: "",//分镜时长
          soundEffect: "",//音效
          specialEffects: "",//特效
          bgm: "",//bgm
          illustration: "",//外部图片
          threeDimensional: "",//转3D
          imgRotate: "",//图片旋转
          imgWatermark: "",//图片擦除
          imgTailor: "",//图片剪切
          imgDislodge: "",//图片剔除
          convertToHD: "",//图片转高清
          turn: "",//图片翻转
        }
      },
      dialogueMode: {
        //台词模式
        tip: '',
        btn: {
          dialogueCopy: "",//台词复制
          dialogueImport: "",//台词导入
        }
      },
      imgEdit: {
        //图片编辑
        tip: '',
        btn: {
          sensitiveOcclusion: "",//敏感遮挡
          automaticTextOcclusion: "",//自动文字遮挡
          changeAllColors: "",//全部改色
          clearAll: "",//全部清除
          newMask: "",//新增遮罩
          isCartoonAnalysis: "",//漫画解析中
        }
      },
      winHead: {
        exportJY: "",//导出至剪映
        resourceExport: "",//资源导出
        browseAll: "",//全片浏览
        exportVideo: "",//视频导出
        cloudExportVideo: "",//云端视频导出
      },
      functionBar: {
        textExtraction: "",//文本提取
        notepad: "",//记事本
        browser: "",//浏览器
        whiteMask: '',//对白遮罩
        camera: '',//镜头
        characterLimit: "",//字符额度
        AISentence: '',//AI句子
        AIProverb: '',//AI谚语
        AIAllegoricalSaying: '',//AI歇后语
        AIPoetry: '',//古诗词
        AITransfer: '',//转写
      },
      other: {
        txt: '',//其他设置
        watermark: {
          txt: '',//水印
          speed: '',//速度
        },
        repeat: '',//自动去重
        cover: '',//封面
        font: {
          txt: '',//字幕设置
          color: '',//字体颜色
          borderColor: '',//文字描边
        },
        backgroundMask: '',//模糊可见
        devicePixelRatio: '',//像素点比例
        cuePhrases: "",//提示语设置
      }
    },

    //用户章节解析状态
    userChapterAnalysisState: false,

    //无损放大生成状态
    losslessHDState: {},
    losslessHDGenerateTotal:0,
    losslessHDNum:0,

    userType: 0//用户类型
  },
  mutations: {
    setUserType(state, type) {
      state.userType = type
    },
    addLensStatus(state, id) {
      if (state.lensStatus.indexOf(id) === -1) {
        state.lensStatus.push(id)
      }
    },
    delLensStatus(state, id) {
      if (state.lensStatus.indexOf(id) !== -1) {
        state.lensStatus.splice(state.lensStatus.indexOf(id), 1)
      }
    },

    addLensError(state, id) {
      if (state.lensError.indexOf(id) === -1) {
        state.lensError.push(id)
      }
    },
    delLensError(state, id) {
      if (state.lensError.indexOf(id) !== -1) {
        state.lensError.splice(state.lensError.indexOf(id), 1)
      }
    },
    clearLensError(state) {
      state.lensError = []
    },

    addVisitedView: (state, view) => {
      if (state.visitedViews.some(v => v.path === view.path && JSON.stringify(v.query) === JSON.stringify(view.query))) return;
      state.visitedViews.push(
        Object.assign({}, view, {
          title: view.name || 'no-name'
        })
      )
    },
    delVisitedView: (state, view) => {
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.path === view.path && JSON.stringify(v.query) === JSON.stringify(view.query)) {
          state.visitedViews.splice(i, 1)
          break
        }
      }
    },
    emptyVisitedView: (state) => {
      state.visitedViews = []
    },
    updataCameraAnimation(state, type) {
      state.cameraAnimation = type
    },
    updataBtnTooltip(state, type) {
      state.btnTooltip = type
    },

    updataCartoonData(state, {type, list}) {
      state.allCartoonData[type] = JSON.parse(JSON.stringify(list))
    },

    setCartoonData(state, {type, index, key, data}) {
      state.allCartoonData[type][index][key] = data;
    },

    delDialogue(state, index) {
      state.allCartoonData.dialogue.splice(index, 1)
    },

    updataCartoonNumData(state, {type, index, json}) {
      let list = JSON.parse(JSON.stringify(state.allCartoonData[type]))
      list[index] = JSON.parse(JSON.stringify(json))
      state.allCartoonData[type] = list
    },

    setLosslessHDState(state, json) {
      state.losslessHDState = json
    },
    upLosslessHDState(state, {key, data}) {
      let pictureState = JSON.parse(JSON.stringify(state.losslessHDState))
      pictureState[key] = data
      state.losslessHDState = pictureState
    },
    delLosslessHDState(state, key) {
      let pictureState = JSON.parse(JSON.stringify(state.losslessHDState))
      delete pictureState[key]
      state.losslessHDState = pictureState
    },
  },
  modules: {
    settings
  }
});

export default store



// WEBPACK FOOTER //
// ./src/store/index.js